import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ImagesService {
  public getImageUrl(image, thumbnail: boolean = false) {
    if (!image || !image.file_name) {
      return '';
    }
    const fileExtension = image.file_name.split('.').pop();
    const _thumbnail = thumbnail ? 'thumbnail' : 'image';
    const companyImageId = image.company_image_id || image.id;

    return `${environment.cloudFrontDomainName}/${image.company_id}/${companyImageId}/${_thumbnail}.${fileExtension}`;
  }
}
